import PropTypes from 'prop-types';
import BaseSelectorReadonlyToInput from "../component/Select/BaseSelectorReadonlyToInput";
import CheckpointService from "./CheckpointService";

class CheckpointSelector extends BaseSelectorReadonlyToInput {

  constructor(props) {
    super(props);
    let url = CheckpointService.ALL_URL;
    if (props.commissioner) {
      url = CheckpointService.COMMISSIONER_URL
    }
    if (props.filter) {
      url += props.filter;
    }

    this.state = {
      ...this.state,
      title: 'Ponto de Controle',
      label: 'friendlyName',
      value: 'id',
      url: url
    };
  }
}

CheckpointSelector.propTypes = {
  required: PropTypes.bool,
  setValue: PropTypes.func,
  defaultValue: PropTypes.string,
  readonly: PropTypes.bool,
  onChange: PropTypes.func,
  commissioner: PropTypes.func
};

export default CheckpointSelector;



// WEBPACK FOOTER //
// ./src/checkpoint/CheckpointSelector.js